import $http from '@Config/axios';
import $store from '@Store';

const prefix = 'movimentacao';

export const MovimentacaoPresenter = {
	storeEntrada(items) {
		return new Promise((resolve, reject) => {
			$http.post(`${prefix}/storeEntrada`, items)
				.then(response => {
					$store.dispatch('SHOW_SNACKBAR', { message: 'Estoque atualizado com sucesso!' });
					resolve(response);
				})
				.catch(response => reject(response));
		});
	},
	storeSaida(items) {
		return new Promise((resolve, reject) => {
			$http.post(`${prefix}/storeSaida`, items)
				.then(response => {
					$store.dispatch('SHOW_SNACKBAR', { message: 'Saída cadastrada com sucesso!' });
					resolve(response);
				})
				.catch(response => reject(response));
		});
	},
	updateMovimentacoes(items) {
		return new Promise((resolve, reject) => {
			$http.post(`${prefix}/updateMovimentacoes`, items)
				.then(response => {
					$store.dispatch('SHOW_SNACKBAR', { message: 'Movimentacao atualizada com sucesso!' });
					resolve(response);
				})
				.catch(response => reject(response));
		});
	}
};
